<template>
    <div class="c-land-right">
        <!-- <div class="c-land-right__header">地块信息</div> -->
        <AsideTitle>地块信息</AsideTitle>
        <div class="c-land-right__content">
            <div class="block-wrap info-form">
                <div class="info-form__title">基本信息</div>

                <FormInfoItem label="名称:">
                    <div>{{ formData.name }}</div>
                </FormInfoItem>
                <FormInfoItem label="地块编号:">
                    <div>{{ formData.code }}</div>
                </FormInfoItem>
                <FormInfoItem label="地块位置:">
                    <div>{{ formData.address }}</div>
                </FormInfoItem>
                <FormInfoItem label="地块类型:">
                    <div>{{ mixin_LandTypeDic[formData.type] }}</div>
                </FormInfoItem>
            </div>
            <!-- <div class="block-wrap time-line-wrap">
                <div style="margin-bottom: 10px">变化时间线</div>
                <TimeLine :data="timeLineDatas" :current="2">
                    <template v-slot:content="scope">
                        {{ scope.data.completeDate }}
                    </template>
                </TimeLine>
            </div> -->
            <div class="block-wrap info-form">
                <div class="info-form__title">整改情况</div>

                <FormInfoItem label="异常内容:">
                    <div></div>
                </FormInfoItem>
                <FormInfoItem label="待整改说明:">
                    <div>{{ currentTimeLineData.remark }}</div>
                </FormInfoItem>
                <FormInfoItem label="要求整个完成时间:">
                    <div>{{ currentTimeLineData.completeDate }}</div>
                </FormInfoItem>
                <FormInfoItem label="处理状态:">
                    <div>{{ currentTimeLineData.isComplete === 0 ? '已整改' : '整改中' }}</div>
                </FormInfoItem>
            </div>
        </div>
    </div>
</template>

<script>
// import TimeLine from './TimeLine.vue';
import FormInfoItem from '../../../components/FormInfoItem.vue';
import { fetchLandDetailById, fetchRectifyList } from '../../Api';
import DicMixin from '../../../mixins/DicMixin';
import AsideTitle from '../../../components/AsideTitle/AsideTitle.vue';

export default {
    mixins: [DicMixin],
    components: {
        // TimeLine,
        FormInfoItem,
        AsideTitle,
    },
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            formData: {},
            timeLineDatas: [
                // { content: '2022.01.11' },
                // { content: '2022.02.21' },
                // { content: '2022.05.06' },
                // {
                //     status: 'error',
                // },
            ],
            currentTimeLineData: {},
        };
    },
    methods: {
        /**
         * 获取地块信息
         */
        getLandDetail() {
            const id = this.id;
            if (id) {
                fetchLandDetailById(id)
                    .run()
                    .then((res) => {
                        this.formData = res || {};
                    });
            }
        },
        /**
         * 获取时间线
         */
        getTimeLine() {
            const id = this.id;
            let list = [];
            if (id) {
                let params = {
                    businessId: id,
                };
                fetchRectifyList(params)
                    .run()
                    .then((res) => {
                        list = res || [];
                        if (list.length > 0) {
                            this.currentTimeLineData = list[0];
                        } else {
                            this.currentTimeLineData = {};
                        }
                        this.timeLineDatas = list;
                    });
            }
        },
        // 获取数据字典
        getDic() {
            this.mixinGetLandTypeDic();
        },
        getData() {
            this.getLandDetail();
            this.getTimeLine();
        },
    },
    created() {
        this.getDic();
    },
    mounted() {
        this.getData();
    },
    watch: {
        id() {
            this.getData();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';
$bg-gray: #4f4f4f;
@include b(land-right, c) {
    @include e(header) {
        height: 48px;
        line-height: 48px;
        background: $bg-gray;
        text-align: center;
        font-size: 24px;
    }
    @include e(content) {
        // color: #000000;
        color: #fff;
        padding: 16px;
    }
    .block-wrap {
        margin-bottom: 20px;
    }
    .info-form {
        &__title {
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 12px;
        }
    }
}
</style>
